import { useQuery } from '@tanstack/react-query'

import { CURRENT_APP_VERSION, fetchLiveAppVersion } from '@/lib/appVersion'
import { QUERY_KEYS } from '@/lib/queryKeys'

const POLL_INTERVAL_MS = 5 * 60 * 1000
const isVersionCheckEnabled = !import.meta.env.DEV && !!CURRENT_APP_VERSION

export function useAppVersionCheck() {
  const { data: liveAppVersion } = useQuery({
    queryKey: [QUERY_KEYS.APP_VERSION],
    queryFn: fetchLiveAppVersion,
    enabled: isVersionCheckEnabled,
    staleTime: 0,
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: false,
  })

  const updateAvailable = !!liveAppVersion?.version && liveAppVersion.version !== CURRENT_APP_VERSION

  const refresh = () => {
    window.location.reload()
  }

  return { updateAvailable, refresh }
}
